export let SubscriptionLevel = /*#__PURE__*/function (SubscriptionLevel) {
  SubscriptionLevel[SubscriptionLevel["Basic"] = 1] = "Basic";
  SubscriptionLevel[SubscriptionLevel["Advanced"] = 2] = "Advanced";
  SubscriptionLevel[SubscriptionLevel["Enterprise"] = 3] = "Enterprise";
  return SubscriptionLevel;
}({});
export let UserRole = /*#__PURE__*/function (UserRole) {
  UserRole[UserRole["Admin"] = 1] = "Admin";
  UserRole[UserRole["Project Manager"] = 2] = "Project Manager";
  UserRole[UserRole["Analyst"] = 3] = "Analyst";
  UserRole[UserRole["Network Partner"] = 4] = "Network Partner";
  UserRole[UserRole["Billing Admin"] = 5] = "Billing Admin";
  return UserRole;
}({});
export let UserType = /*#__PURE__*/function (UserType) {
  UserType[UserType["Client"] = 1] = "Client";
  UserType[UserType["Partner"] = 2] = "Partner";
  UserType[UserType["Admin"] = 3] = "Admin";
  return UserType;
}({});
export let RouteRolesEnum = /*#__PURE__*/function (RouteRolesEnum) {
  RouteRolesEnum["ADMIN"] = "admin";
  RouteRolesEnum["CLIENT"] = "client";
  RouteRolesEnum["PARTNER"] = "partner";
  return RouteRolesEnum;
}({});
export let ROLE_NAME = /*#__PURE__*/function (ROLE_NAME) {
  ROLE_NAME["CLIENT"] = "Client";
  ROLE_NAME["DUAL"] = "Dual account";
  ROLE_NAME["PARTNER"] = "Partner";
  ROLE_NAME["DEFAULT"] = "Role";
  return ROLE_NAME;
}({});
export let CurrentProjectBuilderStep = /*#__PURE__*/function (CurrentProjectBuilderStep) {
  CurrentProjectBuilderStep[CurrentProjectBuilderStep["SERVICE_TYPE"] = 0] = "SERVICE_TYPE";
  CurrentProjectBuilderStep[CurrentProjectBuilderStep["DETAILS"] = 1] = "DETAILS";
  CurrentProjectBuilderStep[CurrentProjectBuilderStep["DUE_DATE"] = 2] = "DUE_DATE";
  CurrentProjectBuilderStep[CurrentProjectBuilderStep["REVIEW_SUBMIT"] = 3] = "REVIEW_SUBMIT";
  return CurrentProjectBuilderStep;
}({});
export let ServiceType = /*#__PURE__*/function (ServiceType) {
  ServiceType["Document Retrieval"] = "0";
  ServiceType["Site Visit"] = "1";
  ServiceType["Due Diligence"] = "2";
  ServiceType["Human Source Enquiry"] = "3";
  ServiceType["Something Else"] = "9";
  return ServiceType;
}({});
export let DueDiligenceTypesEnum = /*#__PURE__*/function (DueDiligenceTypesEnum) {
  DueDiligenceTypesEnum["Red Flag Check"] = "3";
  DueDiligenceTypesEnum["Desktop Due Diligence"] = "0";
  DueDiligenceTypesEnum["Level 1 Due Diligence"] = "1";
  DueDiligenceTypesEnum["Level 2 Due Diligence"] = "2";
  return DueDiligenceTypesEnum;
}({});
export let EnquiriesEnum = /*#__PURE__*/function (EnquiriesEnum) {
  EnquiriesEnum["Lite (2-3 Sources)"] = "1";
  EnquiriesEnum["Standard (4-5 Sources)"] = "2";
  EnquiriesEnum["Extended (6-8 Sources)"] = "3";
  return EnquiriesEnum;
}({});
export let ScopePages = /*#__PURE__*/function (ScopePages) {
  ScopePages[ScopePages["Service Type"] = 0] = "Service Type";
  ScopePages[ScopePages["Details"] = 1] = "Details";
  ScopePages[ScopePages["Due Date"] = 2] = "Due Date";
  ScopePages[ScopePages["Review Submit"] = 3] = "Review Submit";
  return ScopePages;
}({});
export let ReportTypeEnum = /*#__PURE__*/function (ReportTypeEnum) {
  ReportTypeEnum[ReportTypeEnum["Person"] = 1] = "Person";
  ReportTypeEnum[ReportTypeEnum["Business"] = 2] = "Business";
  ReportTypeEnum[ReportTypeEnum["Combined"] = 3] = "Combined";
  return ReportTypeEnum;
}({});
export let PartnerProposalStatus = /*#__PURE__*/function (PartnerProposalStatus) {
  PartnerProposalStatus[PartnerProposalStatus["PENDING"] = -1] = "PENDING";
  PartnerProposalStatus[PartnerProposalStatus["DECLINED"] = 0] = "DECLINED";
  PartnerProposalStatus[PartnerProposalStatus["ACCEPTED"] = 1] = "ACCEPTED";
  return PartnerProposalStatus;
}({});
export let TagRequestMode = /*#__PURE__*/function (TagRequestMode) {
  TagRequestMode["NONE_RELATION"] = "none-relation";
  TagRequestMode["RELATION"] = "relation";
  return TagRequestMode;
}({});
export let ProjectStatusEnum = /*#__PURE__*/function (ProjectStatusEnum) {
  ProjectStatusEnum[ProjectStatusEnum["PENDING"] = 1] = "PENDING";
  ProjectStatusEnum[ProjectStatusEnum["MATCHED"] = 3] = "MATCHED";
  ProjectStatusEnum[ProjectStatusEnum["ACTIVATED"] = 4] = "ACTIVATED";
  ProjectStatusEnum[ProjectStatusEnum["COMPLETED"] = 5] = "COMPLETED";
  ProjectStatusEnum[ProjectStatusEnum["CLOSED"] = 6] = "CLOSED";
  return ProjectStatusEnum;
}({});
export let NPRequestStatusNameEnum = /*#__PURE__*/function (NPRequestStatusNameEnum) {
  NPRequestStatusNameEnum[NPRequestStatusNameEnum["Draft"] = 0] = "Draft";
  NPRequestStatusNameEnum[NPRequestStatusNameEnum["Sent"] = 1] = "Sent";
  NPRequestStatusNameEnum[NPRequestStatusNameEnum["Declined"] = 2] = "Declined";
  NPRequestStatusNameEnum[NPRequestStatusNameEnum["Accepted"] = 3] = "Accepted";
  NPRequestStatusNameEnum[NPRequestStatusNameEnum["Cancelled"] = 4] = "Cancelled";
  NPRequestStatusNameEnum[NPRequestStatusNameEnum["Assigned"] = 5] = "Assigned";
  NPRequestStatusNameEnum[NPRequestStatusNameEnum["AcceptedCancelled"] = 6] = "AcceptedCancelled";
  NPRequestStatusNameEnum[NPRequestStatusNameEnum["Finished"] = 7] = "Finished";
  return NPRequestStatusNameEnum;
}({});
export let ProjectActivityType = /*#__PURE__*/function (ProjectActivityType) {
  ProjectActivityType[ProjectActivityType["PROJECT_MATCHING"] = 1] = "PROJECT_MATCHING";
  ProjectActivityType[ProjectActivityType["PROJECT_MATCHED"] = 2] = "PROJECT_MATCHED";
  ProjectActivityType[ProjectActivityType["PROJECT_ACCEPTED"] = 3] = "PROJECT_ACCEPTED";
  ProjectActivityType[ProjectActivityType["PROJECT_SCOPING"] = 4] = "PROJECT_SCOPING";
  ProjectActivityType[ProjectActivityType["PROJECT_ACTIVE"] = 5] = "PROJECT_ACTIVE";
  ProjectActivityType[ProjectActivityType["REPORT_DRAFT"] = 6] = "REPORT_DRAFT";
  ProjectActivityType[ProjectActivityType["REPORT_ACCEPTED"] = 7] = "REPORT_ACCEPTED";
  ProjectActivityType[ProjectActivityType["REPORT_DOWNLOADED"] = 8] = "REPORT_DOWNLOADED";
  ProjectActivityType[ProjectActivityType["PROJECT_COMPLETED"] = 9] = "PROJECT_COMPLETED";
  ProjectActivityType[ProjectActivityType["PROJECT_CLOSED"] = 10] = "PROJECT_CLOSED";
  ProjectActivityType[ProjectActivityType["PROJECT_NEW_MEMBER"] = 11] = "PROJECT_NEW_MEMBER";
  ProjectActivityType[ProjectActivityType["PROJECT_REMOVE_MEMBER"] = 12] = "PROJECT_REMOVE_MEMBER";
  ProjectActivityType[ProjectActivityType["DOCUMENT_LIBRARY_UPLOAD_FILE"] = 13] = "DOCUMENT_LIBRARY_UPLOAD_FILE";
  ProjectActivityType[ProjectActivityType["DOCUMENT_LIBRARY_DELETE_FILE"] = 14] = "DOCUMENT_LIBRARY_DELETE_FILE";
  ProjectActivityType[ProjectActivityType["DOCUMENT_LIBRARY_MOVE_FOLDER"] = 15] = "DOCUMENT_LIBRARY_MOVE_FOLDER";
  ProjectActivityType[ProjectActivityType["DOCUMENT_LIBRARY_DELETE_FOLDER"] = 16] = "DOCUMENT_LIBRARY_DELETE_FOLDER";
  ProjectActivityType[ProjectActivityType["PROJECT_CREATED"] = 17] = "PROJECT_CREATED";
  return ProjectActivityType;
}({});
export let ProposalStatus = /*#__PURE__*/function (ProposalStatus) {
  ProposalStatus["PENDING"] = "Pending";
  return ProposalStatus;
}({});
export let BatchRequestStatusEnum = /*#__PURE__*/function (BatchRequestStatusEnum) {
  BatchRequestStatusEnum[BatchRequestStatusEnum["PENDING"] = 1] = "PENDING";
  BatchRequestStatusEnum[BatchRequestStatusEnum["ACTIVE"] = 2] = "ACTIVE";
  BatchRequestStatusEnum[BatchRequestStatusEnum["CLOSED"] = 3] = "CLOSED";
  return BatchRequestStatusEnum;
}({});
export let BatchType = /*#__PURE__*/function (BatchType) {
  BatchType["STANDARD"] = "standard";
  BatchType["BATCH"] = "batch";
  BatchType["EXTERNAL"] = "external";
  return BatchType;
}({});
export let SubjectTypes = /*#__PURE__*/function (SubjectTypes) {
  SubjectTypes["subject-type/person"] = "Person";
  SubjectTypes["subject-type/organisation"] = "Organisation";
  SubjectTypes["subject-type/other"] = "Other";
  return SubjectTypes;
}({});
export let ScopeRelatesTo = /*#__PURE__*/function (ScopeRelatesTo) {
  ScopeRelatesTo["Report"] = "0";
  ScopeRelatesTo["Subject"] = "1";
  ScopeRelatesTo["Jurisdiction"] = "2";
  return ScopeRelatesTo;
}({});
export let NPRequestStatus = /*#__PURE__*/function (NPRequestStatus) {
  NPRequestStatus[NPRequestStatus["Draft"] = 0] = "Draft";
  NPRequestStatus[NPRequestStatus["Sent"] = 1] = "Sent";
  NPRequestStatus[NPRequestStatus["Declined"] = 2] = "Declined";
  NPRequestStatus[NPRequestStatus["Accepted"] = 3] = "Accepted";
  NPRequestStatus[NPRequestStatus["Cancelled"] = 4] = "Cancelled";
  NPRequestStatus[NPRequestStatus["Assigned"] = 5] = "Assigned";
  NPRequestStatus[NPRequestStatus["AcceptedCancelled"] = 6] = "AcceptedCancelled";
  NPRequestStatus[NPRequestStatus["Submitted"] = 7] = "Submitted";
  NPRequestStatus[NPRequestStatus["Finished"] = 8] = "Finished";
  return NPRequestStatus;
}({});
export let SiteType = /*#__PURE__*/function (SiteType) {
  SiteType["ADMIN"] = "admin";
  SiteType["NP"] = "np";
  SiteType["CLIENT"] = "client";
  return SiteType;
}({});
export let ProposedPartnerPlacement = /*#__PURE__*/function (ProposedPartnerPlacement) {
  ProposedPartnerPlacement[ProposedPartnerPlacement["FIRST"] = 1] = "FIRST";
  ProposedPartnerPlacement[ProposedPartnerPlacement["SECOND"] = 2] = "SECOND";
  ProposedPartnerPlacement[ProposedPartnerPlacement["TEST"] = 3] = "TEST";
  return ProposedPartnerPlacement;
}({});